import { useEffect, useMemo, useState } from "react";
import {
  JoinRuntimeConnectOptions,
  JoinRuntimeSession,
  JoinRuntimeStatusEvent,
} from "../session/JoinRuntimeSession";
import { MultiplayerOrchestrator } from "../orchestrator/MultiplayerOrchestrator";

interface UseJoinRuntimeResult {
  status: JoinRuntimeStatusEvent;
  progress: number;
  connect: (
    options: JoinRuntimeConnectOptions
  ) => Promise<MultiplayerOrchestrator>;
  cancel: () => void;
  orchestrator: MultiplayerOrchestrator | null;
}

export function useJoinRuntime(): UseJoinRuntimeResult {
  const session = useMemo(() => new JoinRuntimeSession(), []);
  const [status, setStatus] = useState<JoinRuntimeStatusEvent>({ type: "idle" });
  const [progress, setProgress] = useState(0);
  const [orchestrator, setOrchestrator] =
    useState<MultiplayerOrchestrator | null>(null);

  useEffect(() => {
    const unsubStatus = session.onStatus((event) => {
      setStatus(event);
      if (event.type === "ready") {
        // orchestrator will be assigned when connect promise resolves
      } else if (event.type === "idle") {
        setOrchestrator(null);
        setProgress(0);
      }
    });
    const unsubDownload = session.onDownloadProgress(setProgress);
    const unsubReady = session.onReady((readyOrchestrator) => {
      setOrchestrator(readyOrchestrator);
    });

    return () => {
      unsubStatus();
      unsubDownload();
      unsubReady();
    };
  }, [session]);

  const connect = (
    options: JoinRuntimeConnectOptions
  ): Promise<MultiplayerOrchestrator> => {
    return session.connect(options);
  };

  const cancel = () => {
    session.cancel();
    setOrchestrator(null);
  };

  return {
    status,
    progress,
    connect,
    cancel,
    orchestrator,
  };
}


